import React, { useEffect, useState } from 'react';
import { Box, Button, Modal, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { myContainerStyle } from '../../../configs/ui/constant';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import MaterialTable from 'material-table';
import dayjs from 'dayjs';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import Axios from 'axios';
import View from '../../../components/Modal/Activity/View';
import Create from '../../../components/Modal/Activity/Create';
import Edit from '../../../components/Modal/Activity/Edit';
import Delete from '../../../components/Modal/Activity/Delete';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import { ActLable } from '../../../components/Status/StatusLabel';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { faPlus } from '@fortawesome/pro-light-svg-icons';

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
}));

const Activity = () => {
   const history = useHistory();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [resp, setResp] = useState([]);
   const [data, setData] = useState([]);
   const [myModal, setMyModal] = useState('');
   const [showModal, setShowModal] = useState(false);
   useEffect(() => {
      getData();
   }, []);
   const getData = () => {
      setIsLoading(true);
      Axios.get('/GSB/dashboard/activity/GetActivityList')
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               const statusCode = e.response.status;
               if (statusCode === 401) {
                  sessionStorage.clear();
                  localStorage.clear();
                  history.push('/');
               }
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   useEffect(() => {
      setTableData();
   }, [resp]);
   const setTableData = () => {
      if (resp.length > 0) {
         const dataForMap = resp;
         const formatted = dataForMap.map((value) => {
            return Object.assign(
               {},
               {
                  ...value,
                  data: value,
               },
            );
         });
         setIsLoading(false);
         setData(formatted);
      }
   };
   const editDataTable = (data) => {
      setShowModal(false);
      setModalStyle('edit', data);
   };
   const deleteDataTable = (data) => {
      setShowModal(false);
      setModalStyle('delete', data);
   };
   const refreshData = () => {
      setShowModal(false);
      setData([]);
      getData();
   };
   const setModalStyle = (type, value) => {
      if (type === 'view') {
         setMyModal(
            <View
               refID={value}
               onClickClose={() => setShowModal(false)}
               onClickEdit={editDataTable}
               onClickDelete={deleteDataTable}
            />,
         );
      }
      if (type === 'create') {
         setMyModal(
            <Create
               onClickClose={() => setShowModal(false)}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'edit') {
         setMyModal(
            <Edit
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'delete') {
         setMyModal(
            <Delete
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      setShowModal(!showModal);
   };
   return (
      <Paper style={myContainerStyle.root}>
         <Modal className={classes.modal} open={showModal}>
            <React.Fragment>{myModal}</React.Fragment>
         </Modal>
         <Box display='flex' my={1} alignItems='center'>
            <Box mx={1}>
               <Typography variant='h5'>จัดการกิจกรรม</Typography>
            </Box>
            <Box mx={1}>
               <Button
                  variant='contained'
                  color='primary'
                  size='small'
                  startIcon={<FontAwesomeIcon icon={faPlus} />}
                  onClick={() => {
                     setModalStyle('create', '');
                  }}
               >
                  เพิ่มกิจกรรม
               </Button>
            </Box>
         </Box>
         <MaterialTable
            isLoading={isLoading}
            columns={[
               {
                  field: 'activityId',
                  title: 'รหัสกิจกรรม',
               },
               {
                  field: 'status',
                  title: 'สถานะ',
                  sorting: false,
                  export: false,
                  headerStyle: {
                     textAlign: 'center',
                  },
                  cellStyle: {
                     textAlign: 'center',
                  },
                  render: (rowData) => (
                     <ActLable StatusType={rowData.activityStatusDesc} />
                  ),
               },
               {
                  field: 'activityName',
                  title: 'ชื่อกิจกรรม',
                  width: 300,
                  render: (rowData) => rowData.activityNameTh,
               },
               {
                  field: 'ruleCode',
                  title: 'รหัสหลักเกณฑ์',
               },
               {
                  field: 'activityOwnerName',
                  title: 'เจ้าของกิจกรรม',
                  width: 300,
                  render: (rowData) => rowData.activityOwnerNameTh,
               },
               {
                  field: 'formatedAffordPoint',
                  title: 'จำนวนคะแนนที่ให้แล้ว',
                  type: 'numeric',
               },
               {
                  field: 'participantAmount',
                  title: 'จำนวนผู้เข้าร่วม',
                  type: 'numeric',
               },
               {
                  field: 'during',
                  title: 'ระยะเวลา',
                  type: 'datetime',
                  render: (rowData) =>
                     `${dayjs(new Date(rowData.activityStartDate)).format(
                        'DD/MM/BBBB HH:mm',
                     )} - ${dayjs(new Date(rowData.activityEndDate)).format(
                        'DD/MM/BBBB HH:mm',
                     )}`,
               },
            ]}
            data={data}
            options={{
               showTitle: false,
               headerStyle: headerStyle,
               pageSize: 5,
               pageSizeOptions: [5, 10, 25, 50, 100],
            }}
            style={tableStyle}
            icons={tableIcons}
            actions={[
               {
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon
                        ref={ref}
                        {...props}
                        icon={faRedoAlt}
                        size={'xs'}
                     />
                  )),
                  tooltip: 'Refresh Data',
                  isFreeAction: true,
                  onClick: () => refreshData(),
               },
            ]}
            onRowClick={(e, rowData) =>
               setModalStyle('view', rowData.activityId)
            }
         />
      </Paper>
   );
};

export default Activity;
